import { useState } from 'react'
import DataTable from './DataTable'
import { KTSVG } from '../../_metronic/helpers'
import { Link } from "react-router-dom";
import Swal from 'sweetalert2'
import CompetitorCreate from './CompetitorCreate';
import 'react-loading-skeleton/dist/skeleton.css';

function CompetitorList() {

    const hasPermission = 1; //parseInt(GetPagePermission("/setup-company-list"));
    const [newData, setNewData] = useState({});

    const [createCompetitorModalShow, setCreateCompetitorModalShow] = useState(false);

    const handleCreateCompetitorModalShow = () => {
        setCreateCompetitorModalShow(true);
    }

    const handleCreateCompetitorModalClose = (isReload: boolean) => {
        setCreateCompetitorModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const deleteCompetitor = (id: number): void => {
        if (window.confirm("Are you sure you want to delete this competitor?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}competitors/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        setNewData({ id: Date.now() });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    };

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'competitorName', title: 'Competitor', style: { textAlign: 'left' } },
        { value: 'remarks', title: 'Remarks', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <Link to={`/competitor-edit/${row.idCompetitors}`}>
                            <button className="btn btn-light-primary btn-sm">
                                <KTSVG
                                    path='/media/svg/icons/Communication/Write.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Edit
                            </button>
                        </Link>
                        <button className="btn btn-light-danger btn-sm p-2" onClick={() => deleteCompetitor(row.idCompetitors)}>
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        competitorName: {
            filterType: 'like',
            filterValue: '',
        },
        remarks: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'competitors'

    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Competitor List
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateCompetitorModalShow()}><i className="fa fa-plus"></i>Add Competitor</button>
                            </div>
                        </div>
                    </div>

                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                    </div>
                </div>
            }

            <CompetitorCreate show={createCompetitorModalShow} handleClose={handleCreateCompetitorModalClose} id={Date.now()} />

            {/* {hasPermission === 0 &&
                <Error />
            }
            {hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            } */}

        </>
    )
}

export default CompetitorList
